import { attachRowDailyHistoryRunLinks } from '@/features/shared/components/dailyHistoryLinks';
import type { EntityDailyHistoryRow } from '@/features/shared/components/EntityDailyHistoryPanel';
import type { SuiteListItemDto, TestListItemDto } from '@flowqa/shared';

export const buildSuiteHistoryRows = (
  suites: SuiteListItemDto[] | undefined,
  tests: TestListItemDto[] | undefined,
): EntityDailyHistoryRow[] => {
  const testsBySuiteId = new Map<string, TestListItemDto[]>();
  (tests ?? []).forEach((test) => {
    (test.suites?.items ?? []).forEach((suiteRef) => {
      const nextTests = testsBySuiteId.get(suiteRef.id) ?? [];
      nextTests.push(test);
      testsBySuiteId.set(suiteRef.id, nextTests);
    });
  });

  return (suites ?? []).map((suite) =>
    attachRowDailyHistoryRunLinks(
      {
        id: suite.id,
        name: suite.name,
        href: `/suites/${suite.slug}`,
        dailyHistory: suite.dailyHistory ?? [],
        childRows: (testsBySuiteId.get(suite.id) ?? [])
          .slice()
          .sort((left, right) =>
            left.name.localeCompare(right.name, undefined, { sensitivity: 'base' }),
          )
          .map((test) => ({
            id: `${suite.id}-${test.id}`,
            name: test.name,
            href: `/tests/${test.slug}`,
            dailyHistory: test.dailyHistory ?? [],
          })),
      },
      'suite',
    ),
  );
};
